import { Driver, ThumbType } from '~/shared/api'

export const uploadPhoto = async (blob: Blob): Promise<ThumbType> => {
  const uuid = await Driver.uploadMedia(blob)
  const url = URL.createObjectURL(blob)

  return {
    uuid,
    previewUrlDownload: url,
    originalUrlDownload: url,
  }
}
